gsap.set(".co-clients-1-header", { opacity: 0 });
gsap.to(".co-clients-1-header", {
  opacity: 1,
  duration: 0.75,
  ease: "Power4.inOut"
});
gsap.set(".co-clients-logo-grid-cell", { opacity: 0, y: 10 });
gsap.to(".co-clients-logo-grid-cell", {
  opacity: 1,
  y: 0,
  duration: 0.5,
  stagger: 0.01,
  ease: "Power4.inOut"
});
// scrub
gsap.set('.co-clients-5-image-frame img', { top: "0%" });
gsap.to('.co-clients-5-image-frame img', {
  scrollTrigger: {
    trigger: '.co-clients-5',
    start: 'top bottom',
    end: 'bottom top',
    scrub: true
  },
  top: "-10%"
});